import { render, staticRenderFns } from "./AddressAutoComplete.vue?vue&type=template&id=3523aade&scoped=true"
import script from "./AddressAutoComplete.vue?vue&type=script&lang=js"
export * from "./AddressAutoComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3523aade",
  null
  
)

export default component.exports